import axios from "axios";

const RO_FOLDER_API_URL = process.env.REACT_APP_API_URL + "/api/external/ro-folder-demo";
const RO_FOLDER_UPLOAD_API_URL = process.env.REACT_APP_API_URL + "/api/external/ro-folder-upload";
const RO_FOLDER_DELETE_API_URL = process.env.REACT_APP_API_URL + "/api/external/ro-folder-delete";

const getROFolderData = (clientId, clientKey, ro) => {
  const params = new URLSearchParams({
    'client-id': clientId,
    'client-key': clientKey,
    'ro': ro
  });

  return axios.get(`${RO_FOLDER_API_URL}?${params.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 30000
  });
};

const uploadFiles = (clientId, ro, path, files) => {
  const params = new URLSearchParams({
    'client-id': clientId,
    'ro': ro
  });

  const formData = new FormData();
  formData.append('path', path);
  
  files.forEach((file, index) => {
    formData.append(`files`, file);
  });

  return axios.post(`${RO_FOLDER_UPLOAD_API_URL}?${params.toString()}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-api-key': process.env.REACT_APP_EXTERNAL_API_KEY
    },
    timeout: 60000
  });
};

const deleteItems = (clientId, ro, path, folders, files) => {
  const params = new URLSearchParams({
    'client-id': clientId,
    'ro': ro
  });

  const requestData = {
    path: path,
    folders: folders,
    files: files
  };

  return axios.post(`${RO_FOLDER_DELETE_API_URL}?${params.toString()}`, requestData, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_EXTERNAL_API_KEY
    },
    timeout: 60000
  });
};

const roFolderService = {
  getROFolderData,
  uploadFiles,
  deleteItems
};

export default roFolderService;
